
import Text from '@/components/Text/Text';

interface ContentAfterSendRatingProps {
  setShowAcknowledgment(showAcknowledgment: boolean): void;
}

const ContentAfterSendRating = ({
  setShowAcknowledgment,
}: ContentAfterSendRatingProps) => {
  return (
    <>
      <Text
        as='span'
        className='mt-1 block font-bold leading-none'
        size='1xl'
        kind='blue'
      >
        Obrigado!
      </Text>
      <Text
        as='span'
        className='mt-2 block font-normal leading-none'
        size='xs'
        kind='gray'
      >
        Sua avaliação foi registrada com sucesso.
      </Text>
      <button
        type='button'
        className='buttonSend'
        onClick={() => setShowAcknowledgment(false)}
      >
        Alterar Avaliação
      </button>
    </>
  );
};

export default ContentAfterSendRating;
